import type { MouseEvent } from 'react';
import { useEffect, useMemo, useState } from 'react';

import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import type { IGrade } from '@/Module/Grade/Model/DataModel';
import { gradeSelectIds } from '@/Module/Grade/Store/Selector';
import { findGradeSelector } from '@/Module/Grade/Store/Selector/findGradeSelector';
import { useAppSelector } from '@/Module/Store/Hook';

export const useGradeContainerPage = () => {
  const gradeIds = useAppSelector(gradeSelectIds);

  const [selectedGradeId, setSelectedGradeId] = useState<IGrade['id'] | null>(null);
  const [hoveredGradeId, setHoveredGradeId] = useState<IGrade['id'] | null>(null);

  const hoveredGrade = useAppSelector(state => findGradeSelector(state, hoveredGradeId));

  const onBackClick = () => {
    setSelectedGradeId(null);
  };

  const onGradeClick = (event: MouseEvent<HTMLElement>, grade: IGrade) => {
    if (!grade.children?.length) return;

    event.preventDefault();

    if (selectedGradeId && selectedGradeId === grade.id) {
      setSelectedGradeId(null);
      return;
    }

    setSelectedGradeId(grade.id);
  };

  const onGradeMouseIn = (grade: IGrade) => {
    setHoveredGradeId(grade.id);
  };

  const onGradeMouseOut = () => {
    setHoveredGradeId(null);
  };

  const breadcrumbItems: IBreadcrumbItem[] = useMemo(() => {
    return [
      {
        key: 'FIELD',
        title: 'انتخاب پایه',
      },
    ];

    // TODO dependency must be category id
  }, []);

  useEffect(() => {
    if (selectedGradeId) {
      return () => {
        setHoveredGradeId(null);
      };
    }

    return () => {};
  }, [selectedGradeId]);

  return {
    gradeIds,
    hoveredGradeId,
    setHoveredGradeId,
    selectedGradeId,
    setSelectedGradeId,
    onGradeMouseIn,
    onGradeMouseOut,
    onGradeClick,
    onBackClick,
    breadcrumbItems,
    hoveredGrade,
  };
};

export type IGradeContainerPageType = ReturnType<typeof useGradeContainerPage>;
